<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputPassword4">Driver</label>
    <select class='form-control' [class.is-invalid]='this.driverAbsence.driverId === -1' (change)='this.driverAbsence.driverId = +$event.target.value; this.driverAbsence.driver.id = this.driverAbsence.driverId'>
      <option value='-1'>Select a driver</option>
      @for (item of this.drivers; track item) {
        <option [value]='item.id' [selected]='this.driverAbsence.driverId === item.id'>{{ item.firstName }} {{ item.lastName }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Absence type</label>
    <select class='form-control' [class.is-invalid]='this.driverAbsence.driverAbsenceTypeId === -1' (change)='this.driverAbsence.driverAbsenceTypeId = +$event.target.value; this.driverAbsence.driverAbsenceType.id = this.driverAbsence.driverAbsenceTypeId'>
      <option value='-1'>Select a absence type</option>
      @for (item of this.types; track item) {
        <option [value]='item.id' [selected]='this.driverAbsence.driverAbsenceTypeId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Start date</label>
    <input type="date" name='make' [class.is-invalid]='this.driverAbsence.startDate === ""' [(ngModel)]='this.driverAbsence.startDate' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">End Date</label>
    <input type="date" name='make' [class.is-invalid]='this.driverAbsence.endDate === ""'  [(ngModel)]='this.driverAbsence.endDate' class="form-control" id="inputPassword4">
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-12">
    <label for="inputPassword4">Notes</label>
    <textarea name='notes' [(ngModel)]='this.driverAbsence.notes' class="form-control"></textarea>
  </div>
</div>
